import { Application } from "@hotwired/stimulus"

import SignupFormController from "../controllers/signup/form_controller"
import DisableController from "../controllers/support/disable_controller"
import RoleToggleController from "../controllers/signup/role_toggle_controller"
import TestimonialCarouselController from "../controllers/testimonial_carousel_controller"
import PasswordVisibility from "stimulus-password-visibility"
import PasswordValidationController from "../controllers/password_validation_controller"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application
Stimulus.register("signup--form", SignupFormController)
Stimulus.register("support--disable", DisableController)
Stimulus.register("signup--role-toggle", RoleToggleController)
Stimulus.register("testimonial-carousel", TestimonialCarouselController)
Stimulus.register('password-visibility', PasswordVisibility)
Stimulus.register('password-validation', PasswordValidationController)

export { application }
